import type { MermaidElementModel } from './mermaid.js';

export type ReplaceMermaidSourceOptions = {
  /**
   * Keep programmatic replacements (AI/import/MCP) as their own undo step.
   * Interactive typing should mutate the existing Y.Text and use the editor's
   * normal capture window instead of calling this helper per keystroke.
   */
  separateHistory?: boolean;
};

export function replaceMermaidSource(
  model: MermaidElementModel,
  nextSource: string,
  { separateHistory = true }: ReplaceMermaidSourceOptions = {},
) {
  const store = model.surface.store;

  if (separateHistory) {
    store.captureSync();
  }

  store.transact(() => {
    const source = model.source;
    if (source.length > 0) {
      source.delete(0, source.length);
    }
    if (nextSource.length > 0) {
      source.insert(0, nextSource);
    }
  });

  if (separateHistory) {
    store.captureSync();
  }
}
